<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="groupId">
                <span slot="label" ><a-tooltip>{{$t('群组id')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.groupId" :maxLength="32" :placeholder="$t('请输入')+$t('群组id')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="groupName">
                  <span slot="label" ><a-tooltip>{{$t('群名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.groupName" :maxLength="32" :placeholder="$t('请输入')+$t('群名称')" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="introduction">
                  <span slot="label" ><a-tooltip>{{$t('群简介')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.introduction" :maxLength="32" :placeholder="$t('请输入')+$t('群简介')" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="isMute">
                  <span slot="label" ><a-tooltip>{{$t('是否禁言')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select :placeholder="$t('请选择')+$t('是否禁言')" style="width: 100%" v-model="queryParam.isMute" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="isDismiss">
                  <span slot="label" ><a-tooltip>{{$t('是否解散')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select :placeholder="$t('请选择')+$t('是否解散')" style="width: 100%" v-model="queryParam.isDismiss" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communitychatgroup:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitychatgroup:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="ownerAvatar" slot-scope="text, record">
          <div>
            <img v-if="record.ownerAvatar" :src="record.ownerAvatar" style="width:60px;height:62px;" @click="handleRecordPreview(record.ownerAvatar)" alt="none" />
          </div>
        </template>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar" style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none" />
          </div>
        </template>
        <span slot="isDismiss" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum"  :color="true" :color-array="['red','green']" :value="record.isDismiss"/>
        </span>
        <span slot="isMute" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum"  :color="true" :color-array="['red','green']" :value="record.isMute"/>
        </span>
        <span slot="isReport" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum"  :color="true" :color-array="['red','green']" :value="record.isReport"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"  v-if="record.isReport"  v-hasPermi="['community:communitychatgroup:edit']" />
          <a @click="$refs.createForm.handleUpdate(record)"  v-if="record.isReport" v-hasPermi="['community:communitychatgroup:edit']">
             <a-icon type="edit" />{{$t('处理举报')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitychatgroup:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitychatgroup:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitychatgroup:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitychatgroup:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityChatGroup,listCommunityChatGroup, delCommunityChatGroup } from '@/api/community/chatGroup'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityChatGroup',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        groupType: undefined,
        groupId: undefined,
        isReport: undefined,
        groupName: undefined,
        introduction: undefined,
        notification: undefined,
        avatar: undefined,
        applyType: undefined,
        isMute: undefined,
        isDismiss: undefined,
        num: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('群主头像'),
          dataIndex: 'ownerAvatar',
          scopedSlots: { customRender: 'ownerAvatar' },
          align: 'center'
        },
        {
          title: this.$t('群主'),
          dataIndex: 'ownerName',
          align: 'center'
        },
        {
          title: this.$t('群名称'),
          dataIndex: 'groupName',
          align: 'center'
        },
        {
          title: this.$t('群简介'),
          dataIndex: 'introduction',
          align: 'center'
        },
        /*{
          title: this.$t('群头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },*/
        {
          title: this.$t('是否被举报'),
          dataIndex: 'isReport',
          scopedSlots: { customRender: 'isReport' },
          align: 'center'
        },
        {
          title: this.$t('是否禁言'),
          dataIndex: 'isMute',
          scopedSlots: { customRender: 'isMute' },
          align: 'center'
        },
        {
          title: this.$t('是否解散'),
          dataIndex: 'isDismiss',
          scopedSlots: { customRender: 'isDismiss' },
          align: 'center'
        },
        {
          title: this.$t('群人数'),
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询群聊列表 */
    getList () {
      this.loading = true
      pageCommunityChatGroup(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        groupType: undefined,
        groupId: undefined,
        isReport: undefined,
        groupName: undefined,
        introduction: undefined,
        notification: undefined,
        avatar: undefined,
        applyType: undefined,
        isMute: undefined,
        isDismiss: undefined,
        num: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      let reqData = {"id":row.id}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityChatGroup(reqData)
            .then(() => {
              const message = that.$t('删除成功')
              that.$message.success(message,3)
              that.getList()
            })
        },
        onCancel () {
          //取消清空删除ids列表
          this.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/community/chat/group/export',
            that.queryParam
            , `群聊_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>